const css_insReducer = (state = 'N', action) => {
	switch(action.type){
	case 'ADDINSURANCEFLAG':	
		return 'Y';
	case 'REMOVEINSURANCEFLAG':
		return 'N';
	default:
		return state;
	}
}

export default css_insReducer;